import {useEffect, useState} from 'react';
import {signInAvatarUrl} from '../../Auth/signInAvatar';

/** The picture to show for a person: the one they uploaded, else their Gravatar through Outlaw
 * Sign-in, else none (initials only). */
export default function useAvatarPicture(
    uploaded: string | null | undefined,
    email: string | null | undefined,
    resolve: typeof signInAvatarUrl = signInAvatarUrl,
): string | null {
    const [gravatar, setGravatar] = useState<string | null>(null);

    useEffect(() => {
        if (uploaded) return undefined;
        let live = true;
        resolve(email).then(
            url => { if (live) setGravatar(url); },
            () => { if (live) setGravatar(null); },
        );
        return () => { live = false; };
    }, [uploaded, email, resolve]);

    return uploaded || gravatar;
}
